var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,39.75C31.5792,39.75,39.75,31.5792,39.75,21.5C39.75,11.4208,31.5792,3.25,21.5,3.25C11.4208,3.25,3.25,11.4208,3.25,21.5C3.25,31.5792,11.4208,39.75,21.5,39.75ZM21.5,4.75C30.7508,4.75,38.25,12.24923,38.25,21.5C38.25,30.7508,30.7508,38.25,21.5,38.25C12.24923,38.25,4.75,30.7508,4.75,21.5C4.75,12.24923,12.24923,4.75,21.5,4.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,35.75C29.3701,35.75,35.75,29.3701,35.75,21.5C35.75,13.629940000000001,29.3701,7.25,21.5,7.25C13.629940000000001,7.25,7.25,13.629940000000001,7.25,21.5C7.25,29.3701,13.629940000000001,35.75,21.5,35.75ZM21.5,8.75C28.5416,8.75,34.25,14.45837,34.25,21.5C34.25,28.5416,28.5416,34.25,21.5,34.25C14.45837,34.25,8.75,28.5416,8.75,21.5C8.75,14.45837,14.45837,8.75,21.5,8.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,23.72638L13.5,19.273621C13.5,18.846362,13.846362,18.5,14.273621,18.5L15.726379999999999,18.5C16.15364,18.5,16.5,18.846362,16.5,19.273621L16.5,23.72638C16.5,24.15364,16.15364,24.5,15.726379999999999,24.5L14.273621,24.5C13.846362,24.5,13.5,24.15364,13.5,23.72638Z",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,23.72638L19.5,17.273621C19.5,16.846362,19.846362,16.5,20.273621,16.5L21.72638,16.5C22.15364,16.5,22.5,16.846362,22.5,17.273621L22.5,23.72638C22.5,24.15364,22.15364,24.5,21.72638,24.5L20.273621,24.5C19.846362,24.5,19.5,24.15364,19.5,23.72638Z",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,23.72638L25.5,15.273621C25.5,14.846362,25.846362,14.5,26.273621,14.5L27.72638,14.5C28.15364,14.5,28.5,14.846362,28.5,15.273621L28.5,23.72638C28.5,24.15364,28.15364,24.5,27.72638,24.5L26.273621,24.5C25.846362,24.5,25.5,24.15364,25.5,23.72638Z",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,29.25L13.5,29.25L13.5,27.75L29.5,27.75L29.5,29.25Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,33.36632414121232,-15.61409267181034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.53104019165039,33.969669342041016L35.53104019165039,33.969669342041016L35.53104019165039,32.469669342041016L38.53104019165039,32.469669342041016L38.53104019165039,33.969669342041016Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,34.19475010025303,-13.614089974412082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.531036376953125,35.969669342041016L33.531036376953125,35.969669342041016L33.531036376953125,34.469669342041016L36.531036376953125,34.469669342041016L36.531036376953125,35.969669342041016Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,89.5,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.20637,43.642240591430664Q50.09863,44.75004059143066,48.53205,44.75004059143066Q46.965469999999996,44.75004059143066,45.85774,43.642240591430664Q44.749999582767,42.534530591430666,44.75,40.967950591430665Q44.750000298023,39.40137059143066,45.85774,38.29363059143066L51.21203,32.939340591430664L56.5607,38.287970591430664L51.20637,43.642240591430664ZM50.14571,42.581600591430664L54.43934,38.287970591430664L51.21203,35.06066059143066L46.9184,39.35429059143066Q46.25,40.02269059143067,46.25,40.967950591430665Q46.25,41.91321059143066,46.9184,42.581600591430664Q47.58679,43.25004059143066,48.53205,43.25004059143066Q49.47731,43.25004059143066,50.14571,42.581600591430664Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.d0cc940b800164ff15cab2e76715bc8d.svg";
export { ForwardRef as ReactComponent };